










































































































































import { Vue, Component, Watch } from "vue-property-decorator";
import { auth } from '../auth/AuthService';
import router from '../router';
import HelpPopover from '@/HelpPopover.vue'

import * as REPORT_PROBLEM_QUERY from 'src/graphql/ReportProblem.graphql';

declare var USE_AUTH;

@Component({
  components: {
    HelpPopover
  }
})
export default class SCAToolbar extends Vue {
  reportProblemDialog = false;
  sendingProblemReport = false;
  reportProblemDone = false;
  problemDescription = "";
  errorMessage = '';

  get hasProjectLock() {
    return this.$store.getters.hasProjectLock;
  }

  get loadingLock() {
    return this.$store.state.isLoadingLockOwner;
  }

  get project() {
    return this.$store.state.currentProject;
  }

  get projectLockOwner() {
    return this.$store.state.projectLockOwner;
  }

  get projectLockColor() {
    if (this.hasProjectLock) {
      return 'black';
    }

    return this.projectLockOwner ? 'error' : 'black';
  }

  get projectLockIcon() {
    return this.hasProjectLock ? 'lock_open' : 'lock';
  }

  get projectLockText() {
    if (this.hasProjectLock) {
      return 'Click to release edit lock';
    }

    return this.projectLockOwner ? `Click to acquire edit lock from ${this.projectLockOwner.name}` : 'Click to acquire edit lock';
  }

  onToggleDeveloper() {
    this.$store.commit('toggleDeveloperMode');
  }

  onTriggerLogout() {
    auth.logout();
  }

  onToggleLock() {
    const store = this.$store;

    if (this.hasProjectLock) {
      store.commit('releaseProjectLock');
    } else {
      store.commit('acquireProjectLock');
    }
  }

  onClickHome() {
    router.push({ name: 'Home' });
  }

  onReportProblem() {
    this.reportProblemDialog = true;
    this.sendingProblemReport = false;
    this.reportProblemDone = false;
  }

  async onSubmitProblemReport() {
    console.log(`Report simulation problem`, this.problemDescription, this.project.id);
    this.sendingProblemReport = true;
    this.errorMessage = '';

    const res = await this.$apollo.mutate({
      mutation: REPORT_PROBLEM_QUERY,
      variables: {
        projectId: this.project.id,
        message: this.problemDescription
      },
      errorPolicy: 'all',
    });

    if (res != null && res.errors != null) {
      if (res.errors.length > 0) {
        this.errorMessage = res.errors[0].message;
      } else {
        this.errorMessage = 'The email could not be sent. Please try again later or email manually.';
      }

      this.sendingProblemReport = false;
    } else {
      this.reportProblemDialog = false;
      this.reportProblemDone = true;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SCAToolbar.vue